import { BlogListPage } from '~/components/Blog/BlogListPage'

export default function BlogIndexPage() {
  return <BlogListPage />
}